export default {
    help_status: "",
    equipment_id_list: "",
    other_details : "",
    images : "",
};
